import { TTRouteConfig } from "@tt-app/models";
import { ROUTES } from "@tt-app/constants";

const { RELEASE_NOTES } = ROUTES;
export const releaseNotesRoutes: TTRouteConfig[] = [
  {
    name: RELEASE_NOTES.RELEASE_NOTES.NAME,
    path: RELEASE_NOTES.RELEASE_NOTES.PATH,
    type: "page",
    accessLevel: "authenticated",
    component: () => import("@tt-app/views/releaseNotes/ReleaseNotes.vue")
  }
];
